import { css } from "styled-system/css";

export const overlayStyles = css({
  position: "fixed",
  inset: 0,
  zIndex: "50",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "md",
  backgroundColor: "color-mix(in srgb, black 40%, transparent)",
});

export const dialogStyles = css({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  width: "100%",
  maxWidth: "24rem",
  maxHeight: "75dvh",
  overflowY: "auto",
  padding: "lg",
  borderRadius: "large",
  backgroundColor: "bgBase100",
  boxShadow: "0 20px 40px rgba(0, 0, 0, 0.25)",
  color: "textBase",
  fontFamily: "sans",
});

export const headerStyles = css({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: "md",
});

export const titleStyles = css({
  fontFamily: "sans",
  fontSize: "h3",
  fontWeight: "900",
  color: "textBase",
  letterSpacing: "-0.025em",
});

export const closeButtonStyles = css({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: "2rem",
  height: "2rem",
  borderRadius: "medium",
  backgroundColor: "transparent",
  color: "textMuted",
  border: "none",
  cursor: "pointer",
  transitionProperty: "background-color, color",
  transitionDuration: "0.2s",
  _hover: {
    backgroundColor: "bgBase300",
    color: "textBase",
  },
});
